// src/components/Careers/Benefits/BenefitCard.js
import React from 'react';
import './BenefitCard.css';

function BenefitCard({ title, description, imageUrl }) {
  return (
    <div className="benefit-card">
      <img src={imageUrl} alt={title} className="benefit-image" />
      <div className="benefit-content">
        <h3 className="benefit-card-title">{title}</h3>
        <p className="benefit-description">{description}</p>
      </div>
    </div>
  );
}

export default BenefitCard;